import { pdpSharedNotificationMultiplePdpVisitsModalConfig as pdpSharedMultiplePdpVisitsModalConfig } from './PdpSharedNotificationMultiplePdpVisitsModal/pdpSharedNotificationMultiplePdpVisitsModalConfig';
import { pdpSharedNotificationPdpSourcingModalConfig as pdpSharedSourcingModalConfig } from './PdpSharedNotificationPdpSourcingModal/pdpSharedNotificationPdpSourcingModalConfig';
import { config as pdpTradeOnboardingModalConfig } from './PdpSharedNotificationTradeOnboardingModal/config';
import {
    pdpTradeDesignManagerProOnboardingModalConfig,
    pdpTradeDesignManagerStandardOnboardingModalConfig,
} from './PdpSharedNotificationTradeDesignManagerOnboardingModal/pdpSharedNotificationTradeDesignManagerOnboardingModalConfig';
import { pdpSharedNotificationTradeMicroGoalConfig } from './PdpSharedNotificationTradeMicroGoal/pdpSharedNotificationTradeMicroGoalConfig';
import pdpSharedNotificationTradeRequestAppointmentTooltipConfig from './PdpSharedNotificationTradeRequestAppointmentTooltip/pdpSharedNotificationTradeRequestAppointmentTooltipConfig';

export const pdpSharedNotifications = [
    pdpSharedMultiplePdpVisitsModalConfig,
    pdpSharedSourcingModalConfig,
    pdpTradeOnboardingModalConfig,
    pdpTradeDesignManagerProOnboardingModalConfig,
    pdpTradeDesignManagerStandardOnboardingModalConfig,
    pdpSharedNotificationTradeMicroGoalConfig,
    pdpSharedNotificationTradeRequestAppointmentTooltipConfig,
];
